import dlv from 'dlv';

export function getClusterLink({ categoryConfig, browseCategories, browseCategory }) {
	if (dlv(browseCategories, browseCategory + '.link')) {
		return browseCategories[browseCategory].link;
	}
	return `/${categoryConfig.allVerticalClusters ? 'vertical' : 'browse'}/category/${browseCategory}`;
}
